import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress/CircularProgress';
import { Redirect } from 'react-router-dom';
import Retry from './Retry.js';
import { Card, Paper } from '@material-ui/core';
import classNames from 'classnames';
import componentsStyle from 'assets/jss/material-kit-react/views/components.jsx';
import Parallax from '../Parallax/Parallax.jsx';
import GridContainer from '../Grid/GridContainer.jsx';
import GridItem from '../Grid/GridItem.jsx';
import withStyles from '@material-ui/core/styles/withStyles';
import { withTheme } from '@material-ui/core/styles';
import { compose } from 'redux';
class HOCLoader extends React.Component {
    render() {
        const {
            containerClass,
            loadingContainerClass,
            retryContainerClass,
            errorShow,
            retryLink,
            classes
        } = this.props;

        if (this.props.loading) {
            return (
                <div style={{ minHeight: '800px' }}>
                    <div className={'loader-view loader-center'}>
                        <CircularProgress color="primary" />
                    </div>
                </div>
            );
        }
        if (this.props.noResponse) {
            return (
                <div className={retryContainerClass}>
                    <Retry errorMessage={errorShow} retryTo={retryLink} />
                </div>
            );
        }
        if (this.props.redirect) {
            // this.props.history.push({
            //     pathname: this.props.redirectTo
            // });
            return (
                <Redirect
                    to={{
                        pathname: this.props.redirectTo
                    }}
                />
            );
        }

        return <div className={containerClass}>{this.props.children}</div>;
    }
}
const composedComponent = compose(
    withTheme(),
    withStyles(componentsStyle)
);
export default composedComponent(HOCLoader);



// WEBPACK FOOTER //
// ./src/components/HOC/HOCLoader.jsx